import { RouterModule } from '@angular/router';
import { SharedPopupModule } from 'app/shared/popup/popup.module';
import {
  DxTextBoxModule,
  DxDropDownButtonModule,
  DxDataGridModule,
  DxCheckBoxModule,
} from 'devextreme-angular';
import { SharedUtilsModule } from './shared-utils.module';

export const GridUtilsModule = [
  SharedUtilsModule,
  DxTextBoxModule,
  DxDropDownButtonModule,
  DxDataGridModule,
  DxCheckBoxModule,
  RouterModule,
  SharedPopupModule,
];
